export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-13.c7216a74.png";